var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.file != 'null' && _vm.file)?_c('vs-button',{attrs:{"color":"primary","size":"small","href":_vm.link}},[_vm._v("Download")]):_c('span',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }